import { Text } from "@saleor/macaw-ui-next";
import React from "react";
import { FormattedMessage } from "react-intl";

export const NoExtensions = () => (
  <Text size={2} color="default2">
    <FormattedMessage defaultMessage="No extensions found" id="obHpf0" />
  </Text>
);
